import { Box, useTheme } from '@mui/material';
import { DoorBatteryWarningLevel } from 'graphql/generated/graphqlTypes';
import React from 'react';
import BatteryStatusChip from 'v2/components/BatteryChip/BatteryStatusChip';
import { DATAGRID_ROW_HEIGHT } from 'v2/constants';

interface Props {
  level: DoorBatteryWarningLevel;
  iconOnly?: boolean;
}

const BatteryStatusCell: React.FC<Props> = ({ level, iconOnly }) => {
  const theme = useTheme();

  const collapsedStyles = {
    '& .MuiChip-label': { display: 'none', padding: 0 },
    '& .MuiChip-icon': { margin: 0 },
    borderRadius: '50%',
    padding: '3px'
  };

  const chipSx = iconOnly ? collapsedStyles : { [theme.containerQueries.down(80)]: collapsedStyles };

  return (
    <Box
      sx={{
        containerType: 'inline-size',
        width: '100%',
        height: DATAGRID_ROW_HEIGHT,
        display: 'flex',
        justifyContent: iconOnly ? 'center' : 'flex-start',
        alignItems: 'center'
      }}
    >
      <BatteryStatusChip level={level} sx={chipSx} />
    </Box>
  );
};

export default BatteryStatusCell;
